import { useEffect } from "react";
import { TESTIMONIALS } from "@/lib/site";

/** Inject Review + AggregateRating schema for all site testimonials. */
export default function ReviewSchema() {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://yourelitehomecare.com/#business-reviews",
      name: "Elite Home Care by Hortense",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "5.0",
        reviewCount: String(TESTIMONIALS.length),
        bestRating: "5",
        worstRating: "5",
      },
      review: TESTIMONIALS.map((t) => ({
        "@type": "Review",
        author: { "@type": "Person", name: t.name },
        reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
        reviewBody: t.quote,
      })),
    };
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-seo-reviews", "1");
    el.text = JSON.stringify(data);
    document.head.querySelectorAll('script[data-seo-reviews="1"]').forEach((n) => n.remove());
    document.head.appendChild(el);
    return () => {
      document.head.querySelectorAll('script[data-seo-reviews="1"]').forEach((n) => n.remove());
    };
  }, []);
  return null;
}
